import mitt from 'mitt';

/** @type Mitt */
const emitter = mitt();

// Global event bus 🚌
export default emitter;
